import React from 'react';
import {highlightQuery, highlightAndLinkText, extractSnippet} from './various';
import ReactHtmlParser, {convertNodeToElement} from 'react-html-parser';
import mime from 'mime';
import sanitizeHtml from 'sanitize-html';

const transformNode = (node:any, index:number, highlight:string[]) => {
  if (node.type === 'text' || node.data) {
    return ReactHtmlParser(highlightQuery(node.data, highlight));
  }

  if (node.name && (!node.children || !node.children.length)) {
    return convertNodeToElement(node, index, (n) => {
      console.log(n)
      return n
    });
  }

  return node.children.map((child:any, idx: number) => {
    if (child.children) {
      return transformNode(child, idx, highlight);
    }
    if (child.type === 'tag' && child.name === 'a') {
      const nodeTxt = child.children[0].data;
      return <a {...child.attribs}>
        {ReactHtmlParser(highlightQuery(nodeTxt, highlight))}
      </a>
    }
    return <node.name {...child.attribs}>
      {ReactHtmlParser(highlightQuery(child.data, highlight))}
    </node.name>
  })
}

export const highlightUsers = (text: string) => {
  if (!text) {
    return '';
  }
  const pattern = /(?:<at.*?>)(.*?)<\/at>/gm;
  return text.replace(pattern, (match:any) => {
    const slimMatch = match.replace(/<at.*?>/, '').replace(/<\/at>/, '');
    return `<span style="color: #007bff">${slimMatch}</span>`
  })
}

export const formatTeamsResult = (text:string, highlight:string[]) => {
  const processed = sanitizeHtml(text, {
    allowedTags: ['a', 'img', 'span'],
    allowedAttributes: {
      a: ['href'],
      img: ['src', 'style'],
    },
  })
  const parsedText = highlightAndLinkText(highlightUsers(processed), highlight);
  return {
    parsedText: ReactHtmlParser(parsedText),
    parsedSnippet: ReactHtmlParser(extractSnippet(parsedText)),
  }
}

export const getTeamsAttachments = (data:any) => {
  if (data.attachments && data.attachments.length) {
    return data.attachments.map((att:any) => ({
      filename: att.name,
      url: att.contentUrl,
      mimeType: mime.getType(att.name),
    }))
  }
  return []
}